module.exports = __webpack_public_path__ + "static/img/shiqi.493d4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shiqi.png
// module id = C5VS
// module chunks = 1